import React from 'react'
import { Link } from 'react-router-dom'
import UserPic from './components/UserPic'
import { withRouter } from 'react-router-dom'
import Fork from './components/Fork';
import Save from './components/Save'
import { useSelector } from 'react-redux'
import Loader from '../Loader'
import icon from '../../assets/img/icon.png'



const NavBar2 = (props) => {

const { user_data, is_logged_in } = useSelector(state => state.authReducer)
const {pen_title, pen_user_id, pen_user_name, pen_type, saved} = useSelector(state => state.penReducer)


const penAction = () => {
  if(is_logged_in && saved)
  {
    if(user_data.uid === pen_user_id)
        return <Save savePen={props.savePen}/>
    else
        return <Fork fork={props.fork}/>
  } 
  else if(is_logged_in || !saved)
    return <Save savePen={props.savePen}/>
  else 
    return <Fork fork={props.fork}/>
}

const backToPen = () => {
    props.history.push('/')
}
  
const titleChanger = () => {
  return props.match.path === '/editor' ?
    <div className='titleChng'>
      <div className="flex flex-row">
        <input style={{width: (props.penName.length * 13) - ( ((props.penName.length * 13) / 4.3))}} type='text' className='titleInput' value={pen_title} onKeyDown={(e) => e.keyCode === 13 ? props.savePen() : null } onChange={(e) => {
          props.updateName(e)}}/>
        <img src="https://vignette.wikia.nocookie.net/freestyle2/images/7/79/Icon_edit.png/revision/latest?cb=20160907075220" alt="" className='penIcon mt-2' onClick={props.savePen}/>
      </div>
      <p className='APenBy'>New Pen
        {is_logged_in && <Link to='/profile' className='link'><span className='userName'>{user_data.username}</span></Link>}
      </p>
    </div> :(
      <div className='titleChng'>
        <p style={{width: (props.penName.length * 13) - ( ((props.penName.length * 13) / 4.3))}}>{props.penName}</p>
        {
          pen_type === "forked" ? <p className='text-yellow-500 text-xs'>{!is_logged_in ? 'Forked By' : 'Forked from'}
          <Link to={`/profile/${pen_user_id}`} className='ml-2 text-gray-400 hover:text-gray-300 text-bold'><span className='text-sm'>{pen_user_name}</span></Link>
        </p>
        :
        <p className='APenBy'>A PEN BY 
          <Link to={`/profile/${pen_user_id}`} className='link'><span className='userName'>{pen_user_name}</span></Link>
        </p>
        }
    </div>
    )
}
  
  return (
    <div>
      <div className='Nav'>
        <nav className='nav1'>
          <div className='Name2 cursor-pointer'>
            <img className='icon2' onClick={backToPen} src={icon} alt='Icon' />
            <div className='title'>
              {titleChanger()}
            </div>
          </div>
          <div className='nav2'>
            {penAction()}
            <div onClick={() => props.settingsPopUpHandler(!props.showSettings)} className='SettingsBox'>
              <img className='settGear' src="https://cdn2.iconfinder.com/data/icons/web/512/Cog-512.png" alt=""/>
              <p>Settings</p>
            </div>   
            <div>
              <UserPic/>
            </div>
          </div>
        </nav>
      </div>
      {props.penLoading && <Loader />}
    </div>
  )
}
export default withRouter(NavBar2)


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar2.js